import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

import { AppBarSection } from '@densityco/ui';

type TabOnClick = {
  id: string | number,
  label: React.ReactNode,
  disabled?: boolean,
  onClick: () => void,
};

type TabHref = {
  id: string | number,
  label: React.ReactNode,
  disabled?: boolean,
  href: string,
};

type Tab = TabOnClick | TabHref;

const AppBarTabs: React.FunctionComponent<{
  activeTab: Tab['id'],
  tabs: Array<Tab>,
  width?: React.ReactText,
  tabsEqualWidth?: boolean, // Defines if the width of the tab bar is equally split between the tabs, or if they are each the width that their text defines.
}> = ({activeTab, tabs, width, tabsEqualWidth}) => (
  <div className={classnames(styles.tabBar, {[styles.equalWidth]: tabsEqualWidth})} style={{width}}>
    {tabs.map(tab => {
      if (tab.disabled) {
        return (
          <div
            key={tab.id}
            className={classnames(styles.tab, styles.disabled)}
          >
            {tab.label}
          </div>
        );
      }

      if ((tab as any).href) {
        return (
          <a
            key={tab.id}
            data-test-id={`app-bar-tab-${tab.id}`}
            href={(tab as TabHref).href}
            className={classnames(styles.tab, {
              [styles.active]: activeTab === tab.id,
            })}
            tabIndex={0}
            data-active={activeTab === tab.id}
          >
            {tab.label}
          </a>
        );
      } else {
        return (
          <div
            key={tab.id}
            data-test-id={`app-bar-tab-${tab.id}`}
            onClick={(tab as TabOnClick).onClick}
            className={classnames(styles.tab, {
              [styles.active]: activeTab === tab.id,
            })}
            tabIndex={0}
            data-active={activeTab === tab.id}
          >
            {tab.label}
          </div>
        );
      }
    })}
  </div>
);
export default AppBarTabs;
